import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

const CRMStatsDashboard = ({ accessToken }) => {
  const [stats, setStats] = useState({
    totalLeads: 0,
    qualifiedLeads: 0,
    closedOpportunities: 0,
    wonOpportunities: 0,
    lostOpportunities: 0,
  });

  const [accounts, setAccounts] = useState([]);

  const fetchCount = async (url) => {
    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
        Prefer: 'odata.include-annotations="*",odata.maxpagesize=1',
      },
    });
    const json = await res.json();
    return json['@odata.count'] || 0;
  };

  const fetchAccounts = async () => {
    const res = await fetch(
      'https://vehcmcrm.crm5.dynamics.com/api/data/v9.2/accounts?$select=name,accountnumber,telephone1,websiteurl,description',
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
        },
      }
    );
    const json = await res.json();
    return json.value || [];
  };

  useEffect(() => {
    const loadData = async () => {
      const totalLeads = await fetchCount(
        'https://vehcmcrm.crm5.dynamics.com/api/data/v9.2/leads?$top=1&$count=true'
      );
      const qualifiedLeads = await fetchCount(
        'https://vehcmcrm.crm5.dynamics.com/api/data/v9.2/leads?$filter=statuscode eq 3&$count=true'
      );
      const closedOpportunities = await fetchCount(
        'https://vehcmcrm.crm5.dynamics.com/api/data/v9.2/opportunities?$filter=statecode eq 1&$count=true'
      );
      const wonOpportunities = await fetchCount(
        'https://vehcmcrm.crm5.dynamics.com/api/data/v9.2/opportunities?$filter=statuscode eq 3&$count=true'
      );
      const lostOpportunities = await fetchCount(
        'https://vehcmcrm.crm5.dynamics.com/api/data/v9.2/opportunities?$filter=statuscode eq 4&$count=true'
      );
      const accountsData = await fetchAccounts();

      setStats({
        totalLeads,
        qualifiedLeads,
        closedOpportunities,
        wonOpportunities,
        lostOpportunities,
      });
      setAccounts(accountsData);
    };

    if (accessToken) loadData();
  }, [accessToken]);

  if (accounts.length > 0 && stats.totalLeads > 0) {
    return (
      <Box>
        {[
          { label: 'Total Leads', value: stats.totalLeads },
          { label: 'Qualified Leads', value: stats.qualifiedLeads },
          { label: 'Closed Opportunities', value: stats.closedOpportunities },
          { label: 'Won Opportunities', value: stats.wonOpportunities },
          { label: 'Lost Opportunities', value: stats.lostOpportunities },
        ].map((item, index) => (
          <>
            <div>
              {item.label}: {item.value}
            </div>
            <hr />
          </>
        ))}
        <Box>
          <h3>Account Names</h3>
          <ul>
            {accounts.map((acc) => (
              <li key={acc.accountid}>{acc.name || ''}</li>
            ))}
          </ul>
        </Box>
      </Box>
    );
  }
  return <Box></Box>;
};

export default CRMStatsDashboard;
